import Error404Page from "~/pages/error404Page/Error404Page";

const commonRoutes = [
  { key: "404", path: "*", exact: true, component: Error404Page },
];

export default commonRoutes;
